import React, { createContext, useMemo, useState } from "react";
import axios from "./utils/axios";
import Cookie from "./utils/cookie";
import { ACCESS_TOKEN } from "./constants";

const Store = createContext();
const { Provider } = Store;

const GlobalState = ({ children }) => {
  const [isLoading, setLoading] = useState(null);
  const [accessToken, setAccessToken] = useState(Cookie.get(ACCESS_TOKEN));

  axios.interceptors.request.use(
    (config) => {
      if (
        config?.headers?.common?.withoutLoading === undefined ||
        !config.headers.common.withoutLoading
      ) {
        setLoading(true);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      const { config } = response;
      if (
        config?.headers?.withoutLoading === undefined ||
        !config.headers.withoutLoading
      ) {
        setLoading(false);
      }

      const accessTokenCookie = Cookie.get(ACCESS_TOKEN);
      accessToken !== accessTokenCookie && setAccessToken(accessTokenCookie);
      return response;
    },
    async (error) => {
      console.log({ error });
      setLoading(false);
      return Promise.reject(error);
    }
  );

  const value = useMemo(
    () => ({ user: accessToken, isLoading, setLoading }),
    [accessToken, isLoading]
  );

  return <Provider value={value}>{children}</Provider>;
};

export { GlobalState, Store };
